// ============================================================================
// GLOBAL USER ENDPOINTS
// ============================================================================
// Endpoint definitions for Global User lookup (username check, tenant access)

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';

/**
 * Base path for global user endpoints
 */
const BASE_PATH = '/globalusers';

/**
 * Global User Endpoints
 */
export const globalUserEndpoints = {
  /**
   * Check if a global user exists by username
   * GET /globalusers/exists/:username
   */
  exists: (username: string) =>
    buildEndpointWithParams(`${BASE_PATH}/exists/:username`, { username }),

  /**
   * Get global user by username
   * GET /globalusers/username/:username
   */
  getByUsername: (username: string) =>
    buildEndpointWithParams(`${BASE_PATH}/username/:username`, { username }),

  /**
   * Get all tenant access records for a global user
   * GET /globalusers/:id/tenant-access
   */
  tenantAccess: (id: string) =>
    buildEndpointWithParams(`${BASE_PATH}/:id/tenant-access`, { id }),
} as const;

export default globalUserEndpoints;
